import { useSelector } from 'react-redux'

export const useAuth = () => {
  const user = useSelector((state) => state.user)
  return user && !user.error && !user.anonymous ? true : false
}
